import { render } from "./RatingsScale.vue?vue&type=template&id=64304f34&scoped=true"
import script from "./RatingsScale.vue?vue&type=script&lang=js"
export * from "./RatingsScale.vue?vue&type=script&lang=js"

import "./RatingsScale.vue?vue&type=style&index=0&id=64304f34&scoped=true&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64304f34"]])

export default __exports__